import Avatar from 'emerald-ui/lib/Avatar';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Avatar, componentName: 'Avatar' }], 'Avatar'),
  description: 'The Avatar shows the initials of the user and changes its background color according to said initials.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Avatar },
      whiteBackground: true,
      code: `<Avatar />`,
    },
  ],
};
